import { makeRequest } from "./api";
import axiosInstance from "../interceptors/axiosInterceptor";

export const FetchLocations = async () => {
  return makeRequest("/api/admin/homePageSettings/popular/locations/fetch");
};

export const SearchCities = async (search = "") => {
  const res = await axiosInstance.get(
    `/api/search/home/cities?search=${encodeURIComponent(search)}`,
  );
  return res.data;
};

export const CreateLocation = async (image, name, status) => {
  const formData = new FormData();
  formData.append("image", image);
  formData.append("name", JSON.stringify(name));
  formData.append("status", status);

  return makeRequest("/api/admin/homePageSettings/popular/locations/create", {
    method: "POST",
    data: formData,
  });
};

export const UpdateLocation = async (id, image, name) => {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("name", JSON.stringify(name));
  if (image instanceof File) {
    formData.append("image", image);
  }

  return makeRequest(`/api/admin/homePageSettings/popular/locations/update`, {
    method: "PUT",
    data: formData,
  });
};

export const DeleteLocation = async (id) => {
  return makeRequest(
    "/api/admin/homePageSettings/popular/locations/disable/delete",
    {
      method: "PUT",
      data: {
        data: {
          id: id,
        },
      },
    },
  );
};
